export default "__VITE_ASSET__DW3eB5fB__"